import React from 'react';
import { connect } from 'react-redux';
import RecentBookingHeader from './RecentBookingHeader/RecentBookingHeader';
import RecentBookingTuple from './RecentBookingTuple/RecentBookingTuple';
import RecentBookingTupleHeader from './RecentBookingTupleHeader/RecentBookingTupleHeader';

import HeadingH3 from '../UI/Headings/HeadingH3/HeadingH3';
import HeadingH4 from '../UI/Headings/HeadingH4/HeadingH4';

import { toggleRecentBookingType } from '../../store/actions/index';
import noDataImage from './img/rb-no-data.png';

const recentBooking = (props) => {

    let rt = props.rt;
    let ut = props.ut;
    let pt = props.pt;

    let content = null;
    let tupleHeader = null;

    let noData = <div className={`u-textAlignCenter u-height100Percent u-flex f-column justify-content-center align-items-center pt-8`}>
            <div className={`mb-3 u-width250`}>
                <img className={`u-block mx-auto u-width70Percent u-phone-width50Percent`} src={noDataImage} alt='No Data'/>
            </div>            
            <div className={`mb-2`}>
                <HeadingH3 size={24} weight="Medium" color="Dark">Sorry!</HeadingH3>
            </div>
            <div>
                <HeadingH4 size={16} weight="Regular" color="Light">No data to display for the selected category</HeadingH4>
            </div>
        </div>;

    if (props.recentBookingType === 1) {
        if (rt.length === 0) {
            content = noData;
        } else {
            tupleHeader = <RecentBookingTupleHeader />;
            content = rt.map((recentBookingData, index) => {
                return <div key={index} className={`mb-2 phone-mb-4`}><RecentBookingTuple data={recentBookingData}/></div>;
            })
        }
    } else if (props.recentBookingType === 2) {
        if (ut.length === 0) {
            content = noData;
        } else {
            tupleHeader = <RecentBookingTupleHeader />;
            content = ut.map((recentBookingData, index) => {
                return <div key={index} className={`mb-2 phone-mb-4`}><RecentBookingTuple data={recentBookingData}/></div>;
            })   
        }
    } else if (props.recentBookingType === 3) {
        if (pt.length === 0) {
            content = noData;
        } else {
            tupleHeader = <RecentBookingTupleHeader />;
            content = pt.map((recentBookingData, index) => {
                return <div key={index} className={`mb-2 phone-mb-4`}><RecentBookingTuple data={recentBookingData}/></div>;
            })
        }
    }

    return (
        <div>
            <div>
                <RecentBookingHeader recentBookingType={props.recentBookingType} onToggleRecentBookingType={props.onToggleRecentBookingType}/>
            </div>
            <div className={`u-minHeight260`}>
                {tupleHeader}
                {content}
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        recentBookingType: state.ui.recentBookingType
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleRecentBookingType: (type) => dispatch(toggleRecentBookingType(type))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(recentBooking);



// WEBPACK FOOTER //
// ./src/components/RecentBooking/RecentBooking.js